export default class Constants {
  static FORGOT_PASSWORD = 'Forgot Password?';
  static DONT_HAVE_ACCOUNT = 'Don\'t have account?';

  //Button text
  static SEND_BUTTON_TEXT = 'Send';

  //Animation Type
  static FADE_ANIMATION = 'fade';

};

